import React from "react";

import { ResumeContainer, Col, Row, Link } from "./index.style";
import { Container, Title } from "../index.style";
import PlaceHolder from "../../../images/resume.png";

const Resume = () => {
  return (
    <ResumeContainer>
      <Container>
        <Row>
          <Col className="col">
            <img src={PlaceHolder} alt="QuirkyCoders Resume" />
          </Col>
          <Col className="col resume">
            <Title>QuirkyCoders Resume</Title>
            <p>
              Search over 150 million resumes, across your industry. Target your
              search by industry, education, title, location and more and start
              a conversation with your next great hire.
            </p>
            <Link href="/subscriptions">
              Learn more about hiring with QuirkyCoders resume
            </Link>
          </Col>
        </Row>
      </Container>
    </ResumeContainer>
  );
};

export default Resume;
